/* Source: /home/runner/work/jaseci-blogs/jaseci-blogs/pages/submit.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Link } from "@jac/runtime";
import { useState } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
const _jac = {
  int: {
    bit_length(n) {
      if (n === 0) return 0;
      return Math.floor(Math.log2(Math.abs(n))) + 1;
    },
    bit_count(n) {
      let x = Math.abs(n);
      let count = 0;
      while (x) { count += x & 1; x >>= 1; }
      return count;
    },
    to_bytes(n, length, byteorder) {
      const bytes = [];
      let val = n < 0 ? (1 << (length * 8)) + n : n;
      for (let i = 0; i < length; i++) {
        bytes.push(val & 0xff);
        val >>= 8;
      }
      if (byteorder === "big") bytes.reverse();
      return bytes;
    },
    from_bytes(bytes, byteorder) {
      const b = byteorder === "big" ? bytes : [...bytes].reverse();
      let result = 0;
      for (const byte of b) result = (result << 8) | byte;
      return result;
    },
    mod(a, b) { return ((a % b) + b) % b; }
  },

  float: {
    as_integer_ratio(f) {
      if (!isFinite(f)) throw new _jac.exc.ValueError("cannot convert " + f + " to integer ratio");
      if (f === 0) return [0, 1];
      let num = f, den = 1;
      while (num !== Math.floor(num)) { num *= 2; den *= 2; }
      const g = _jac.float._gcd(Math.abs(num), den);
      return [num / g, den / g];
    },
    _gcd(a, b) { while (b) { [a, b] = [b, a % b]; } return a; },
    hex(f) {
      return f.toString(16);
    },
    fromhex(s) {
      return parseFloat(s);
    },
    mod(a, b) { return ((a % b) + b) % b; }
  },

  complex: {
    conjugate(c) { return {re: c.re, im: -c.im}; },
    add(a, b) { return {re: a.re + b.re, im: a.im + b.im}; },
    sub(a, b) { return {re: a.re - b.re, im: a.im - b.im}; },
    mul(a, b) { return {re: a.re * b.re - a.im * b.im, im: a.re * b.im + a.im * b.re}; },
    truediv(a, b) {
      const d = b.re * b.re + b.im * b.im;
      return {re: (a.re * b.re + a.im * b.im) / d, im: (a.im * b.re - a.re * b.im) / d};
    },
    pow(a, b) {
      if (typeof b === "number") b = {re: b, im: 0};
      if (typeof a === "number") a = {re: a, im: 0};
      if (b.im === 0 && Number.isInteger(b.re)) {
        let result = {re: 1, im: 0};
        for (let i = 0; i < Math.abs(b.re); i++) result = _jac.complex.mul(result, a);
        return b.re < 0 ? _jac.complex.truediv({re: 1, im: 0}, result) : result;
      }
      const r = Math.sqrt(a.re * a.re + a.im * a.im);
      const theta = Math.atan2(a.im, a.re);
      const lnr = Math.log(r);
      const newR = Math.exp(lnr * b.re - theta * b.im);
      const newTheta = lnr * b.im + theta * b.re;
      return {re: newR * Math.cos(newTheta), im: newR * Math.sin(newTheta)};
    },
    eq(a, b) {
      if (typeof b === "number") b = {re: b, im: 0};
      if (typeof a === "number") a = {re: a, im: 0};
      return a.re === b.re && a.im === b.im;
    },
    neg(a) { return {re: -a.re, im: -a.im}; },
    pos(a) { return {re: +a.re, im: +a.im}; }
  },

  str: {
    capitalize(s) {
      if (s.length === 0) return s;
      return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    },
    title(s) {
      return s.replace(/\b\w/g, c => c.toUpperCase());
    },
    swapcase(s) {
      return [...s].map(c => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase()).join("");
    },
    count(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      if (sub === "") return t.length + 1;
      let count = 0, pos = 0;
      while ((pos = t.indexOf(sub, pos)) !== -1) { count++; pos += sub.length; }
      return count;
    },
    find(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      const idx = t.indexOf(sub);
      return idx === -1 ? -1 : idx + (start || 0);
    },
    rfind(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      const idx = t.lastIndexOf(sub);
      return idx === -1 ? -1 : idx + (start || 0);
    },
    index(s, sub, start, end) {
      const idx = _jac.str.find(s, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    rindex(s, sub, start, end) {
      const idx = _jac.str.rfind(s, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    startswith(s, prefix, start, end) {
      return s.slice(start || 0, end).startsWith(prefix);
    },
    endswith(s, suffix, start, end) {
      return s.slice(start || 0, end).endsWith(suffix);
    },
    replace(s, old, new_, count) {
      if (count === undefined) return s.split(old).join(new_);
      let result = s, n = 0;
      while (n < count) {
        const idx = result.indexOf(old);
        if (idx === -1) break;
        result = result.slice(0, idx) + new_ + result.slice(idx + old.length);
        n++;
      }
      return result;
    },
    strip(s, chars) {
      if (!chars) return s.trim();
      let start = 0, end = s.length;
      while (start < end && chars.indexOf(s[start]) !== -1) start++;
      while (end > start && chars.indexOf(s[end - 1]) !== -1) end--;
      return s.slice(start, end);
    },
    lstrip(s, chars) {
      if (!chars) return s.trimStart();
      let start = 0;
      while (start < s.length && chars.indexOf(s[start]) !== -1) start++;
      return s.slice(start);
    },
    rstrip(s, chars) {
      if (!chars) return s.trimEnd();
      let end = s.length;
      while (end > 0 && chars.indexOf(s[end - 1]) !== -1) end--;
      return s.slice(0, end);
    },
    removeprefix(s, prefix) {
      return s.startsWith(prefix) ? s.slice(prefix.length) : s;
    },
    removesuffix(s, suffix) {
      return (suffix && s.endsWith(suffix)) ? s.slice(0, -suffix.length) : s;
    },
    split(s, sep, maxsplit) {
      if (sep === undefined || sep === null) {
        const parts = s.trim().split(/\s+/);
        if (maxsplit === undefined) return parts;
        if (maxsplit <= 0) return [s];
        return [...parts.slice(0, maxsplit), parts.slice(maxsplit).join(" ")].filter(x => x !== undefined);
      }
      if (maxsplit === undefined) return s.split(sep);
      const parts = s.split(sep);
      if (parts.length <= maxsplit + 1) return parts;
      return [...parts.slice(0, maxsplit), parts.slice(maxsplit).join(sep)];
    },
    rsplit(s, sep, maxsplit) {
      if (maxsplit === undefined) return _jac.str.split(s, sep);
      const parts = s.split(sep);
      if (parts.length <= maxsplit + 1) return parts;
      const keep = parts.length - maxsplit;
      return [parts.slice(0, keep).join(sep), ...parts.slice(keep)];
    },
    splitlines(s, keepends) {
      const lines = s.split(/(\r\n|\r|\n)/);
      const result = [];
      for (let i = 0; i < lines.length; i += 2) {
        const line = lines[i];
        const sep = lines[i + 1] || "";
        if (line || sep) result.push(keepends ? line + sep : line);
      }
      return result;
    },
    partition(s, sep) {
      const idx = s.indexOf(sep);
      if (idx === -1) return [s, "", ""];
      return [s.slice(0, idx), sep, s.slice(idx + sep.length)];
    },
    rpartition(s, sep) {
      const idx = s.lastIndexOf(sep);
      if (idx === -1) return ["", "", s];
      return [s.slice(0, idx), sep, s.slice(idx + sep.length)];
    },
    format(s, ...args) {
      let i = 0;
      return s.replace(/\{(\w*)\}/g, (match, key) => {
        if (key === "") return args[i++];
        if (!isNaN(key)) return args[parseInt(key)];
        return args[0] && typeof args[0] === "object" ? args[0][key] : match;
      });
    },
    format_map(s, mapping) {
      return s.replace(/\{(\w+)\}/g, (match, key) => key in mapping ? mapping[key] : match);
    },
    center(s, width, fillchar) {
      const fc = fillchar || " ";
      if (s.length >= width) return s;
      const total = width - s.length;
      const left = Math.floor(total / 2);
      return fc.repeat(left) + s + fc.repeat(total - left);
    },
    zfill(s, width) {
      if (s.length >= width) return s;
      const sign = (s[0] === "+" || s[0] === "-") ? s[0] : "";
      const body = sign ? s.slice(1) : s;
      return sign + "0".repeat(width - s.length) + body;
    },
    expandtabs(s, tabsize) {
      const ts = tabsize === undefined ? 8 : tabsize;
      let result = "", col = 0;
      for (const c of s) {
        if (c === "\t") { const sp = ts - (col % ts); result += " ".repeat(sp); col += sp; }
        else if (c === "\n" || c === "\r") { result += c; col = 0; }
        else { result += c; col++; }
      }
      return result;
    },
    isnumeric(s) {
      if (s.length === 0) return false;
      return [...s].every(c => /[\d\u00B2\u00B3\u00B9\u00BC-\u00BE\u2150-\u218F]/.test(c));
    },
    istitle(s) {
      return s === _jac.str.title(s) && /[A-Za-z]/.test(s);
    },
    translate(s, table) {
      return [...s].map(c => {
        const code = c.charCodeAt(0);
        if (code in table) {
          const v = table[code];
          if (v === null) return "";
          if (typeof v === "number") return String.fromCharCode(v);
          return v;
        }
        return c;
      }).join("");
    },
    maketrans(...args) {
      const table = {};
      if (args.length === 1) {
        const mapping = args[0];
        for (const [k, v] of Object.entries(mapping)) {
          table[typeof k === "string" ? k.charCodeAt(0) : k] = v;
        }
      } else if (args.length >= 2) {
        const from_ = args[0], to_ = args[1];
        for (let i = 0; i < from_.length; i++) {
          table[from_.charCodeAt(i)] = to_.charCodeAt(i);
        }
        if (args[2]) {
          for (const c of args[2]) table[c.charCodeAt(0)] = null;
        }
      }
      return table;
    },
    mod(s, args) {
      let i = 0;
      const a = Array.isArray(args) ? args : [args];
      return s.replace(/%([sd%])/g, (m, fmt) => {
        if (fmt === "%") return "%";
        return String(a[i++]);
      });
    }
  },

  // Runtime-polymorphic method dispatch, used when the codegen cannot prove
  // the static type of a method-call receiver (e.g. a `dict`-typed prop, the
  // result of `or` widening, or a comprehension over an untyped value) and so
  // cannot pick a typed emitter. The compiler emits
  // `_jac.poly.call(obj, "name", ...args)`; `call` resolves the *runtime* type
  // of `obj` and applies the matching Python operation, forwards to a
  // same-named method on a user-defined object, or raises AttributeError. The
  // per-type tables below carry the trivial native-mapped methods inline and
  // delegate the non-trivial ones to the shared `_jac.str/list/dict/set`
  // helpers, so each operation has a single implementation and no Python
  // method name can leak verbatim into the emitted JavaScript.
  poly: {
    _typename(o) {
      if (o === null || o === undefined) return "NoneType";
      if (Array.isArray(o)) return "list";
      if (o instanceof Set) return "set";
      if (o instanceof Map) return "dict";
      if (o instanceof Uint8Array) return "bytes";
      const t = typeof o;
      if (t === "string") return "str";
      if (t === "boolean") return "bool";
      if (t === "number") return Number.isInteger(o) ? "int" : "float";
      if (t === "object") return (o.constructor && o.constructor.name) || "object";
      return t;
    },
    // --- per-runtime-type Python method tables (keyed by Python name) ---
    // Trivial native-mapped ops are inline; non-trivial ones delegate to the
    // shared `_jac.<type>` helpers (which the typed emitters also use), so the
    // typed and polymorphic paths share one implementation.
    _str: {
      lower: (s) => s.toLowerCase(),
      upper: (s) => s.toUpperCase(),
      casefold: (s) => s.toLowerCase(),
      strip: (s, chars) => {
        if (chars === undefined) return s.trim();
        let i = 0, j = s.length;
        while (i < j && chars.indexOf(s[i]) !== -1) i++;
        while (j > i && chars.indexOf(s[j - 1]) !== -1) j--;
        return s.slice(i, j);
      },
      lstrip: (s, chars) => {
        if (chars === undefined) return s.replace(/^\s+/, "");
        let i = 0;
        while (i < s.length && chars.indexOf(s[i]) !== -1) i++;
        return s.slice(i);
      },
      rstrip: (s, chars) => {
        if (chars === undefined) return s.replace(/\s+$/, "");
        let j = s.length;
        while (j > 0 && chars.indexOf(s[j - 1]) !== -1) j--;
        return s.slice(0, j);
      },
      join: (s, parts) => Array.from(parts, x => String(x)).join(s)
    },
    _list: {
      append: (a, x) => { a.push(x); return null; },
      clear: (a) => { a.length = 0; return null; },
      copy: (a) => a.slice(),
      count: (a, x) => _jac.list.count(a, x),
      extend: (a, b) => { for (const v of b) a.push(v); return null; },
      index: (a, x, start, end) => _jac.list.index(a, x, start, end),
      insert: (a, i, x) => { a.splice(i, 0, x); return null; },
      pop: (a, i) => {
        if (i === undefined) return a.pop();
        const idx = i < 0 ? a.length + i : i;
        return a.splice(idx, 1)[0];
      },
      remove: (a, x) => _jac.list.remove(a, x),
      reverse: (a) => { a.reverse(); return null; },
      sort: (a, key) => _jac.list.sort(a, key)
    },
    _dict: {
      clear: (o) => _jac.dict.clear(o),
      copy: (o) => ({ ...o }),
      // Python `dict.get`: returns the stored value when the key is present
      // (even if it is null), and the default only when the key is absent.
      // A membership check is required — `o[key] ?? default_` would wrongly
      // substitute the default for a present-but-null value.
      get: (o, key, default_) =>
        Object.prototype.hasOwnProperty.call(o, key) ? o[key] : default_,
      items: (o) => Object.entries(o),
      keys: (o) => Object.keys(o),
      pop: (o, key, default_) => _jac.dict.pop(o, key, default_),
      popitem: (o) => _jac.dict.popitem(o),
      setdefault: (o, key, default_) => _jac.dict.setdefault(o, key, default_),
      update: (o, other) => {
        if (other instanceof Map) { for (const [k, v] of other) o[k] = v; }
        else if (Array.isArray(other)) { for (const [k, v] of other) o[k] = v; }
        else if (other) { for (const k of Object.keys(other)) o[k] = other[k]; }
        return null;
      },
      values: (o) => Object.values(o)
    },
    _set: {
      add: (s, x) => { s.add(x); return null; },
      clear: (s) => { s.clear(); return null; },
      copy: (s) => new Set(s),
      difference: (a, b) => _jac.set.difference(a, b),
      difference_update: (s, o) => _jac.set.difference_update(s, o),
      discard: (s, x) => { s.delete(x); return null; },
      intersection: (a, b) => _jac.set.intersection(a, b),
      intersection_update: (s, o) => _jac.set.intersection_update(s, o),
      isdisjoint: (a, b) => _jac.set.isDisjointFrom(a, b instanceof Set ? b : new Set(b)),
      issubset: (a, b) => _jac.set.isSubsetOf(a, b instanceof Set ? b : new Set(b)),
      issuperset: (a, b) => _jac.set.isSupersetOf(a, b instanceof Set ? b : new Set(b)),
      pop: (s) => _jac.set.pop(s),
      remove: (s, x) => _jac.set.remove(s, x),
      symmetric_difference: (a, b) => _jac.set.symmetricDifference(a, b),
      symmetric_difference_update: (s, o) => _jac.set.symmetric_difference_update(s, o),
      union: (a, b) => _jac.set.union(a, b),
      update: (s, o) => _jac.set.update(s, o)
    },
    // Jac dicts compile to plain objects, but interop code may hand us a real
    // Map; mirror the dict methods over the Map API for that case.
    _map: {
      clear: (m) => { m.clear(); return null; },
      copy: (m) => new Map(m),
      get: (m, key, default_) => (m.has(key) ? m.get(key) : default_),
      items: (m) => [...m.entries()],
      keys: (m) => [...m.keys()],
      pop: (m, key, default_) => {
        if (m.has(key)) { const v = m.get(key); m.delete(key); return v; }
        if (default_ !== undefined) return default_;
        throw new _jac.exc.KeyError("KeyError: " + key);
      },
      popitem: (m) => {
        if (m.size === 0) throw new _jac.exc.KeyError("dictionary is empty");
        const key = [...m.keys()].pop();
        const val = m.get(key);
        m.delete(key);
        return [key, val];
      },
      setdefault: (m, key, default_) => {
        if (!m.has(key)) m.set(key, default_ === undefined ? null : default_);
        return m.get(key);
      },
      update: (m, other) => {
        if (other instanceof Map) { for (const [k, v] of other) m.set(k, v); }
        else if (Array.isArray(other)) { for (const [k, v] of other) m.set(k, v); }
        else if (other) { for (const k of Object.keys(other)) m.set(k, other[k]); }
        return null;
      },
      values: (m) => [...m.values()]
    },
    // Single entry point. `obj.method(...args)` on a receiver whose static
    // type is not provably primitive is compiled to
    // `_jac.poly.call(obj, "method", ...args)`.
    call(o, m, ...args) {
      // 1. Genuine JS primitives get Python-semantic dispatch: a plain object
      //    is a Python dict, an Array is a list, a Set/Map/string/number/bytes
      //    maps to its Python counterpart. These are the types whose Python
      //    method semantics differ from (or have no) native JS equivalent.
      if (typeof o === "string") {
        if (_jac.poly._str[m]) return _jac.poly._str[m](o, ...args);
        if (_jac.str[m]) return _jac.str[m](o, ...args);
      } else if (typeof o === "number") {
        const ns = Number.isInteger(o) ? _jac.int : _jac.float;
        if (ns && ns[m]) return ns[m](o, ...args);
      } else if (Array.isArray(o)) {
        if (_jac.poly._list[m]) return _jac.poly._list[m](o, ...args);
      } else if (o instanceof Set) {
        if (_jac.poly._set[m]) return _jac.poly._set[m](o, ...args);
      } else if (o instanceof Map) {
        if (_jac.poly._map[m]) return _jac.poly._map[m](o, ...args);
      } else if (o instanceof Uint8Array) {
        if (_jac.bytes[m]) return _jac.bytes[m](o, ...args);
      } else if (
        o !== null && o !== undefined && typeof o === "object"
        && (Object.getPrototypeOf(o) === Object.prototype
            || Object.getPrototypeOf(o) === null)
      ) {
        // A plain object is a Python dict literal.
        if (_jac.poly._dict[m]) return _jac.poly._dict[m](o, ...args);
      }
      // 2. Otherwise forward to a same-named method the receiver carries
      //    itself: a user-defined class instance, a host/framework object
      //    (Headers, URLSearchParams, ...), a callable with attached methods,
      //    or a Set/Map/Array method not mirrored above. This matches the
      //    direct `obj.method(...)` that a typed call would have emitted.
      if (o !== null && o !== undefined && typeof o[m] === "function") {
        return o[m](...args);
      }
      // 3. Nothing applies: raise the Python-style error instead of leaking a
      //    method name or silently returning a wrong value.
      throw new _jac.exc.AttributeError(
        "'" + _jac.poly._typename(o) + "' object has no attribute '" + m + "'");
    },
    // Backward-compatible named shims. The compiler now emits `call`, but a
    // previously-built bundle may still reference a named helper; these route
    // it through the same dispatcher (rest params preserve the arg count).
    lower(s, ...r) { return _jac.poly.call(s, "lower", ...r); },
    upper(s, ...r) { return _jac.poly.call(s, "upper", ...r); },
    strip(s, ...r) { return _jac.poly.call(s, "strip", ...r); },
    lstrip(s, ...r) { return _jac.poly.call(s, "lstrip", ...r); },
    rstrip(s, ...r) { return _jac.poly.call(s, "rstrip", ...r); },
    append(a, ...r) { return _jac.poly.call(a, "append", ...r); },
    extend(a, ...r) { return _jac.poly.call(a, "extend", ...r); },
    pop(a, ...r) { return _jac.poly.call(a, "pop", ...r); },
    get(o, ...r) { return _jac.poly.call(o, "get", ...r); },
    contains(c, x) {
      // Python-equivalent membership for a value of unknown static type.
      // string -> substring; array (list/tuple/range) -> element;
      // Set/Map -> key/element; plain object (dict) -> own key.
      if (typeof c === "string") return c.includes(x);
      if (Array.isArray(c)) return c.includes(x);
      if (c instanceof Set || c instanceof Map) return c.has(x);
      if (c !== null && typeof c === "object") {
        return Object.prototype.hasOwnProperty.call(c, x);
      }
      return false;
    },
    getitem(c, i) {
      // Subscript read for a value of unknown static type. This is a faithful
      // superset of a raw `c[i]`: it only adds Python's negative indexing for
      // sequences (string/array) and otherwise preserves JS semantics exactly
      // (mapping/object access, out-of-range -> `undefined`, no new throws).
      if (typeof i === "number" && i < 0
          && (typeof c === "string" || Array.isArray(c))) {
        return c[c.length + i];
      }
      if (c instanceof Map) return c.get(i);
      return c[i];
    },
    setitem(c, i, v) {
      // Subscript assignment for a value of unknown/list static type. A
      // negative index writes the array element counted from the end (a raw
      // JS `c[-1] = v` would instead create a bogus "-1" property); every
      // other case behaves like a plain `c[i] = v`.
      if (typeof i === "number" && i < 0 && Array.isArray(c)) {
        c[c.length + i] = v;
        return v;
      }
      if (c instanceof Map) { c.set(i, v); return v; }
      c[i] = v;
      return v;
    },
    and_(a, bf) {
      // Python `a and b`: returns `a` when it is falsy, else evaluates and
      // returns `b`. `bf` is a thunk so the right operand keeps short-circuit
      // (lazy) evaluation, and `a` is evaluated exactly once by the caller.
      return _jac.builtin.bool(a) ? bf() : a;
    },
    or_(a, bf) {
      // Python `a or b`: returns `a` when it is truthy, else `b`.
      return _jac.builtin.bool(a) ? a : bf();
    }
  },

  list: {
    remove(arr, val) {
      const i = arr.indexOf(val);
      if (i === -1) throw new _jac.exc.ValueError("list.remove(x): x not in list");
      arr.splice(i, 1);
    },
    index(arr, val, start, end) {
      const s = start || 0;
      const e = end === undefined ? arr.length : end;
      for (let i = s; i < e; i++) {
        if (arr[i] === val) return i;
      }
      throw new _jac.exc.ValueError(val + " is not in list");
    },
    count(arr, val) {
      let c = 0;
      for (const item of arr) { if (item === val) c++; }
      return c;
    },
    sort(arr, key) {
      if (key) {
        arr.sort((a, b) => {
          const ka = key(a), kb = key(b);
          return ka < kb ? -1 : ka > kb ? 1 : 0;
        });
      } else {
        arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      }
    },
    repeat(arr, n) {
      const result = [];
      for (let i = 0; i < n; i++) result.push(...arr);
      return result;
    },
    eq(a, b) { return JSON.stringify(a) === JSON.stringify(b); },
    lt(a, b) {
      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
      }
      return a.length < b.length;
    },
    gt(a, b) { return _jac.list.lt(b, a); },
    le(a, b) { return _jac.list.eq(a, b) || _jac.list.lt(a, b); },
    ge(a, b) { return _jac.list.eq(a, b) || _jac.list.gt(a, b); },
    imul(arr, n) {
      const orig = [...arr];
      arr.length = 0;
      for (let i = 0; i < n; i++) arr.push(...orig);
      return arr;
    }
  },

  dict: {
    pop(d, key, default_) {
      if (key in d) { const v = d[key]; delete d[key]; return v; }
      if (default_ !== undefined) return default_;
      throw new _jac.exc.KeyError("KeyError: " + key);
    },
    popitem(d) {
      const keys = Object.keys(d);
      if (keys.length === 0) throw new _jac.exc.KeyError("dictionary is empty");
      const key = keys[keys.length - 1];
      const val = d[key];
      delete d[key];
      return [key, val];
    },
    setdefault(d, key, default_) {
      if (!(key in d)) d[key] = default_ === undefined ? null : default_;
      return d[key];
    },
    clear(d) {
      for (const key of Object.keys(d)) delete d[key];
    },
    fromkeys(keys, value) {
      const d = {};
      const v = value === undefined ? null : value;
      for (const k of keys) d[k] = v;
      return d;
    },
    eq(a, b) {
      const ka = Object.keys(a), kb = Object.keys(b);
      if (ka.length !== kb.length) return false;
      for (const k of ka) {
        if (!(k in b)) return false;
        const va = a[k], vb = b[k];
        if (va !== vb) {
          if (typeof va === "object" && typeof vb === "object" && va !== null && vb !== null) {
            if (JSON.stringify(va) !== JSON.stringify(vb)) return false;
          } else return false;
        }
      }
      return true;
    }
  },

  set: {
    remove(s, val) {
      if (!s.has(val)) throw new _jac.exc.KeyError("KeyError: " + val);
      s.delete(val);
    },
    pop(s) {
      if (s.size === 0) throw new _jac.exc.KeyError("pop from an empty set");
      const val = s.values().next().value;
      s.delete(val);
      return val;
    },
    update(s, other) { for (const v of other) s.add(v); },
    intersection_update(s, other) {
      const otherSet = other instanceof Set ? other : new Set(other);
      for (const v of s) { if (!otherSet.has(v)) s.delete(v); }
    },
    difference_update(s, other) {
      for (const v of other) s.delete(v);
    },
    symmetric_difference_update(s, other) {
      for (const v of other) { if (s.has(v)) s.delete(v); else s.add(v); }
    },
    union(a, b) {
      const r = new Set(a);
      for (const v of b) r.add(v);
      return r;
    },
    intersection(a, b) {
      const bs = b instanceof Set ? b : new Set(b);
      const r = new Set();
      for (const v of a) { if (bs.has(v)) r.add(v); }
      return r;
    },
    difference(a, b) {
      const bs = b instanceof Set ? b : new Set(b);
      const r = new Set();
      for (const v of a) { if (!bs.has(v)) r.add(v); }
      return r;
    },
    symmetricDifference(a, b) {
      const r = new Set(a);
      for (const v of b) { if (r.has(v)) r.delete(v); else r.add(v); }
      return r;
    },
    isSubsetOf(a, b) {
      if (a.size > b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    },
    isSupersetOf(a, b) { return _jac.set.isSubsetOf(b, a); },
    isDisjointFrom(a, b) {
      for (const v of a) { if (b.has(v)) return false; }
      return true;
    },
    is_proper_subset(a, b) {
      if (a.size >= b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    },
    is_proper_superset(a, b) { return _jac.set.is_proper_subset(b, a); },
    eq(a, b) {
      if (a.size !== b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    }
  },

  bytes: {
    hex(b) {
      return Array.from(b).map(x => x.toString(16).padStart(2, "0")).join("");
    },
    fromhex(s) {
      const arr = [];
      const clean = s.replace(/\s/g, "");
      for (let i = 0; i < clean.length; i += 2) arr.push(parseInt(clean.substr(i, 2), 16));
      return new Uint8Array(arr);
    },
    _indexOf(b, sub, start, end) {
      const s = start || 0;
      const e = end === undefined ? b.length : end;
      const sl = sub.length;
      if (sl === 0) return s;
      for (let i = s; i <= e - sl; i++) {
        let m = true;
        for (let j = 0; j < sl; j++) { if (b[i + j] !== sub[j]) { m = false; break; } }
        if (m) return i;
      }
      return -1;
    },
    _lastIndexOf(b, sub, start, end) {
      const s = start || 0;
      const e = end === undefined ? b.length : end;
      const sl = sub.length;
      if (sl === 0) return e;
      for (let i = e - sl; i >= s; i--) {
        let m = true;
        for (let j = 0; j < sl; j++) { if (b[i + j] !== sub[j]) { m = false; break; } }
        if (m) return i;
      }
      return -1;
    },
    count(b, sub) {
      let c = 0, p = 0;
      while (p <= b.length - sub.length) {
        const idx = _jac.bytes._indexOf(b, sub, p);
        if (idx === -1) break;
        c++; p = idx + sub.length;
      }
      return c;
    },
    find(b, sub, start, end) { return _jac.bytes._indexOf(b, sub, start, end); },
    rfind(b, sub, start, end) { return _jac.bytes._lastIndexOf(b, sub, start, end); },
    index(b, sub, start, end) {
      const idx = _jac.bytes._indexOf(b, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    rindex(b, sub, start, end) {
      const idx = _jac.bytes._lastIndexOf(b, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    startswith(b, prefix, start, end) {
      const s = start || 0;
      if (prefix.length > b.length - s) return false;
      for (let i = 0; i < prefix.length; i++) { if (b[s + i] !== prefix[i]) return false; }
      return true;
    },
    endswith(b, suffix, start, end) {
      const e = end === undefined ? b.length : end;
      if (suffix.length > e) return false;
      const off = e - suffix.length;
      for (let i = 0; i < suffix.length; i++) { if (b[off + i] !== suffix[i]) return false; }
      return true;
    },
    replace(b, old_, new_, count) {
      const r = [];
      let pos = 0, n = 0;
      const max = count === undefined ? Infinity : count;
      while (pos <= b.length) {
        if (n < max) {
          const idx = _jac.bytes._indexOf(b, old_, pos);
          if (idx !== -1) {
            for (let i = pos; i < idx; i++) r.push(b[i]);
            for (let i = 0; i < new_.length; i++) r.push(new_[i]);
            pos = idx + old_.length; n++;
            continue;
          }
        }
        for (let i = pos; i < b.length; i++) r.push(b[i]);
        break;
      }
      return new Uint8Array(r);
    },
    _isWS(c) { return c === 32 || c === 9 || c === 10 || c === 13 || c === 11 || c === 12; },
    strip(b, chars) {
      let s = 0, e = b.length;
      if (chars) { const cs = new Set(chars); while (s < e && cs.has(b[s])) s++; while (e > s && cs.has(b[e-1])) e--; }
      else { while (s < e && _jac.bytes._isWS(b[s])) s++; while (e > s && _jac.bytes._isWS(b[e-1])) e--; }
      return b.slice(s, e);
    },
    lstrip(b, chars) {
      let s = 0;
      if (chars) { const cs = new Set(chars); while (s < b.length && cs.has(b[s])) s++; }
      else { while (s < b.length && _jac.bytes._isWS(b[s])) s++; }
      return b.slice(s);
    },
    rstrip(b, chars) {
      let e = b.length;
      if (chars) { const cs = new Set(chars); while (e > 0 && cs.has(b[e-1])) e--; }
      else { while (e > 0 && _jac.bytes._isWS(b[e-1])) e--; }
      return b.slice(0, e);
    },
    removeprefix(b, prefix) {
      if (_jac.bytes.startswith(b, prefix)) return b.slice(prefix.length);
      return b.slice();
    },
    removesuffix(b, suffix) {
      if (suffix.length > 0 && _jac.bytes.endswith(b, suffix)) return b.slice(0, b.length - suffix.length);
      return b.slice();
    },
    split(b, sep, maxsplit) {
      const parts = [];
      let pos = 0, n = 0;
      const max = maxsplit === undefined ? Infinity : maxsplit;
      while (pos <= b.length) {
        if (n >= max) { parts.push(b.slice(pos)); return parts; }
        const idx = _jac.bytes._indexOf(b, sep, pos);
        if (idx === -1) { parts.push(b.slice(pos)); return parts; }
        parts.push(b.slice(pos, idx));
        pos = idx + sep.length; n++;
      }
      if (pos <= b.length) parts.push(b.slice(pos));
      return parts;
    },
    rsplit(b, sep, maxsplit) {
      if (maxsplit === undefined) return _jac.bytes.split(b, sep);
      const parts = [];
      let end = b.length, n = 0;
      while (end >= 0 && n < maxsplit) {
        const idx = _jac.bytes._lastIndexOf(b, sep, 0, end);
        if (idx === -1) break;
        parts.unshift(b.slice(idx + sep.length, end));
        end = idx; n++;
      }
      parts.unshift(b.slice(0, end));
      return parts;
    },
    splitlines(b, keepends) {
      const result = [];
      let start = 0;
      for (let i = 0; i < b.length; i++) {
        if (b[i] === 10 || b[i] === 13) {
          let eol = i + 1;
          if (b[i] === 13 && i + 1 < b.length && b[i + 1] === 10) eol++;
          result.push(keepends ? b.slice(start, eol) : b.slice(start, i));
          start = eol;
          if (eol > i + 1) i++;
        }
      }
      if (start < b.length) result.push(b.slice(start));
      return result;
    },
    join(sep, parts) {
      if (parts.length === 0) return new Uint8Array(0);
      const r = [];
      for (let i = 0; i < parts.length; i++) {
        if (i > 0) for (const x of sep) r.push(x);
        for (const x of parts[i]) r.push(x);
      }
      return new Uint8Array(r);
    },
    partition(b, sep) {
      const idx = _jac.bytes._indexOf(b, sep);
      if (idx === -1) return [b.slice(), new Uint8Array(0), new Uint8Array(0)];
      return [b.slice(0, idx), sep.slice(), b.slice(idx + sep.length)];
    },
    rpartition(b, sep) {
      const idx = _jac.bytes._lastIndexOf(b, sep);
      if (idx === -1) return [new Uint8Array(0), new Uint8Array(0), b.slice()];
      return [b.slice(0, idx), sep.slice(), b.slice(idx + sep.length)];
    },
    _isUp(c) { return c >= 65 && c <= 90; },
    _isLo(c) { return c >= 97 && c <= 122; },
    _isAl(c) { return (c >= 65 && c <= 90) || (c >= 97 && c <= 122); },
    _isDig(c) { return c >= 48 && c <= 57; },
    capitalize(b) {
      if (b.length === 0) return new Uint8Array(0);
      const r = new Uint8Array(b.length);
      r[0] = _jac.bytes._isLo(b[0]) ? b[0] - 32 : b[0];
      for (let i = 1; i < b.length; i++) r[i] = _jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i];
      return r;
    },
    lower(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) r[i] = _jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i];
      return r;
    },
    upper(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) r[i] = _jac.bytes._isLo(b[i]) ? b[i] - 32 : b[i];
      return r;
    },
    title(b) {
      const r = new Uint8Array(b.length);
      let prev = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isAl(b[i])) {
          r[i] = prev ? (_jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i]) : (_jac.bytes._isLo(b[i]) ? b[i] - 32 : b[i]);
          prev = true;
        } else { r[i] = b[i]; prev = false; }
      }
      return r;
    },
    swapcase(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) r[i] = b[i] + 32;
        else if (_jac.bytes._isLo(b[i])) r[i] = b[i] - 32;
        else r[i] = b[i];
      }
      return r;
    },
    center(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const total = width - b.length;
      const left = Math.floor(total / 2);
      const r = new Uint8Array(width);
      r.fill(f, 0, left); r.set(b, left); r.fill(f, left + b.length);
      return r;
    },
    ljust(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      r.set(b); r.fill(f, b.length);
      return r;
    },
    rjust(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      const off = width - b.length;
      r.fill(f, 0, off); r.set(b, off);
      return r;
    },
    zfill(b, width) {
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      let off = 0;
      if (b.length > 0 && (b[0] === 43 || b[0] === 45)) { r[0] = b[0]; off = 1; }
      const pad = width - b.length;
      r.fill(48, off, off + pad);
      for (let i = off; i < b.length; i++) r[pad + i] = b[i];
      return r;
    },
    expandtabs(b, tabsize) {
      const ts = tabsize === undefined ? 8 : tabsize;
      const r = [];
      let col = 0;
      for (let i = 0; i < b.length; i++) {
        if (b[i] === 9) { const sp = ts - (col % ts); for (let j = 0; j < sp; j++) r.push(32); col += sp; }
        else if (b[i] === 10 || b[i] === 13) { r.push(b[i]); col = 0; }
        else { r.push(b[i]); col++; }
      }
      return new Uint8Array(r);
    },
    translate(b, table, del_) {
      const r = [];
      const ds = del_ ? new Set(del_) : null;
      for (let i = 0; i < b.length; i++) {
        if (ds && ds.has(b[i])) continue;
        r.push(table && table[b[i]] !== undefined ? table[b[i]] : b[i]);
      }
      return new Uint8Array(r);
    },
    maketrans(from_, to_) {
      const t = new Uint8Array(256);
      for (let i = 0; i < 256; i++) t[i] = i;
      for (let i = 0; i < from_.length; i++) t[from_[i]] = to_[i];
      return t;
    },
    isalnum(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isAl(b[i]) && !_jac.bytes._isDig(b[i])) return false;
      return true;
    },
    isalpha(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isAl(b[i])) return false;
      return true;
    },
    isascii(b) {
      for (let i = 0; i < b.length; i++) if (b[i] > 127) return false;
      return true;
    },
    isdigit(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isDig(b[i])) return false;
      return true;
    },
    islower(b) {
      let has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) return false;
        if (_jac.bytes._isLo(b[i])) has = true;
      }
      return has;
    },
    isupper(b) {
      let has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isLo(b[i])) return false;
        if (_jac.bytes._isUp(b[i])) has = true;
      }
      return has;
    },
    isspace(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isWS(b[i])) return false;
      return true;
    },
    istitle(b) {
      let prev = false, has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) { if (prev) return false; prev = true; has = true; }
        else if (_jac.bytes._isLo(b[i])) { if (!prev) return false; prev = true; has = true; }
        else prev = false;
      }
      return has;
    },
    add(a, b) {
      const r = new Uint8Array(a.length + b.length);
      r.set(a); r.set(b, a.length);
      return r;
    },
    mul(b, n) {
      const r = new Uint8Array(b.length * n);
      for (let i = 0; i < n; i++) r.set(b, i * b.length);
      return r;
    },
    mod(b, args) {
      const s = new TextDecoder().decode(b);
      return new TextEncoder().encode(_jac.str.mod(s, args));
    },
    eq(a, b) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
      return true;
    },
    lt(a, b) {
      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
      }
      return a.length < b.length;
    },
    gt(a, b) { return _jac.bytes.lt(b, a); },
    le(a, b) { return _jac.bytes.eq(a, b) || _jac.bytes.lt(a, b); },
    ge(a, b) { return _jac.bytes.eq(a, b) || _jac.bytes.gt(a, b); },
    contains(b, sub) { return _jac.bytes._indexOf(b, sub) !== -1; }
  },

  tuple: {
    count(arr, val) { return _jac.list.count(arr, val); },
    index(arr, val, start, end) { return _jac.list.index(arr, val, start, end); },
    repeat(arr, n) { return _jac.list.repeat(arr, n); },
    eq(a, b) { return _jac.list.eq(a, b); },
    lt(a, b) { return _jac.list.lt(a, b); },
    gt(a, b) { return _jac.list.gt(a, b); },
    le(a, b) { return _jac.list.le(a, b); },
    ge(a, b) { return _jac.list.ge(a, b); }
  },

  range: {
    count(r, val) {
      if (typeof r[Symbol.iterator] === "function") {
        let c = 0;
        for (const v of r) { if (v === val) c++; }
        return c;
      }
      return 0;
    },
    index(r, val) {
      let i = 0;
      for (const v of r) { if (v === val) return i; i++; }
      throw new _jac.exc.ValueError(val + " is not in range");
    },
    eq(a, b) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) { if (a[i] !== b[i]) return false; }
      return true;
    },
    contains(r, val) {
      for (const v of r) { if (v === val) return true; }
      return false;
    }
  },

  // Builtin types as first-class values -- `map(int, xs)`, `key=str`,
  // `f = int`, `[str, int]`.  In Python `int` is a single object playing two
  // roles, so it lowers to a single object here too: a callable whose body is
  // generated from the same emitters the direct-call path uses (so
  // `f = int; f(x)` can never drift from `int(x)`), carrying the
  // `__jac_type__` tag that isinstance/issubclass compare against.
  types: (() => {
    const _t = (tag, fn) => Object.assign(fn, {
      __jac_type__: tag,
      toString: () => "<class '" + tag + "'>"
    });
    return {
    any: _t("any", (...a) => (a[0].some(Boolean))),
    bool: _t("bool", (...a) => a.length === 0 ? (false) : a.length === 1 ? (_jac.builtin.bool(a[0])) : (_jac.builtin.bool(a[0], a[1]))),
    bytes: _t("bytes", (...a) => a.length === 0 ? (new Uint8Array()) : (new Uint8Array(a[0]))),
    dict: _t("dict", (...a) => a.length === 0 ? ({}) : (Object.fromEntries(a[0]))),
    float: _t("float", (...a) => a.length === 0 ? (0.0) : (parseFloat(a[0]))),
    int: _t("int", (...a) => a.length === 0 ? (0) : a.length === 1 ? (Math.trunc(Number(a[0]))) : (parseInt(a[0], a[1]))),
    list: _t("list", (...a) => a.length === 0 ? ([]) : (Array.from(a[0]))),
    set: _t("set", (...a) => a.length === 0 ? (new Set()) : (new Set(a[0]))),
    str: _t("str", (...a) => a.length === 0 ? ("") : (String(a[0]))),
    tuple: _t("tuple", (...a) => a.length === 0 ? (Object.freeze([])) : (Object.freeze(Array.from(a[0])))),
    type: _t("type", (...a) => (typeof a[0]))
    };
  })(),

  builtin: {
    round(n, ndigits) {
      if (ndigits === undefined) return Math.round(n);
      const f = Math.pow(10, ndigits);
      return Math.round(n * f) / f;
    },
    sum(iterable, start) {
      let total = start || 0;
      for (const v of iterable) total += v;
      return total;
    },
    sorted(iterable, key, reverse) {
      const arr = [...iterable];
      if (key) {
        arr.sort((a, b) => {
          const ka = key(a), kb = key(b);
          return ka < kb ? -1 : ka > kb ? 1 : 0;
        });
      } else {
        arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      }
      if (reverse) arr.reverse();
      return arr;
    },
    enumerate(iterable, start) {
      const s = start || 0;
      return [...iterable].map((v, i) => [s + i, v]);
    },
    zip(...iterables) {
      const arrays = iterables.map(it => [...it]);
      const len = Math.min(...arrays.map(a => a.length));
      const result = [];
      for (let i = 0; i < len; i++) {
        result.push(arrays.map(a => a[i]));
      }
      return result;
    },
    map(fn, ...iterables) {
      // Python hands the callback exactly one element per iterable, while JS's
      // `Array.prototype.map` would also hand it (index, array) -- which a
      // two-arity callable like `int(x, base)` reads as a radix.
      if (iterables.length === 1) return [...iterables[0]].map((v) => fn(v));
      const arrays = iterables.map(it => [...it]);
      const len = Math.min(...arrays.map(a => a.length));
      const result = [];
      for (let i = 0; i < len; i++) {
        result.push(fn(...arrays.map(a => a[i])));
      }
      return result;
    },
    filter(fn, iterable) {
      return [...iterable].filter((v) => fn ? fn(v) : v);
    },
    // The Python type of a builtin-type value, as a tag string.  A builtin type
    // reaches classinfo position in either of the two spellings the compiler
    // emits: the runtime type object (`_jac.types.int`, which carries the tag)
    // or the bare tag itself (an erased annotation, or `_typename` output).
    _typeTag(t) {
      return (t !== null && t !== undefined && t.__jac_type__) || t;
    },
    // Python subclass relation over builtin-type tags. `object` is the
    // universal base and `bool` is a subclass of `int`; `tuple` and `frozenset`
    // share JS representations with `list`/`set`, so fold those aliases to
    // their runtime tag first. One source of truth so isinstance and issubclass
    // can never disagree.
    _tagSubclass(subTag, superTag) {
      const fold = (t) => {
        const tag = _jac.builtin._typeTag(t);
        return tag === "tuple" ? "list" : tag === "frozenset" ? "set" : tag;
      };
      const sub = fold(subTag), sup = fold(superTag);
      if (sup === "object") return true;
      if (sub === sup) return true;
      if (sup === "int" && sub === "bool") return true;
      return false;
    },
    isinstance(o, classinfo) {
      // isinstance(x, (A, B, ...)) -- the tuple of types lowers to a JS array;
      // match if `o` is an instance of any member.
      if (Array.isArray(classinfo)) {
        for (const c of classinfo) {
          if (_jac.builtin.isinstance(o, c)) return true;
        }
        return false;
      }
      // Builtin type: compare the value's runtime type against its tag via the
      // shared subclass relation.  Checked before the constructor branch --
      // a type object is a callable too, and `o instanceof int` is meaningless.
      const tag = _jac.builtin._typeTag(classinfo);
      if (typeof tag === "string") {
        return _jac.builtin._tagSubclass(_jac.poly._typename(o), tag);
      }
      // User archetype / JS constructor.
      if (typeof classinfo === "function") return o instanceof classinfo;
      return false;
    },
    issubclass(cls, classinfo) {
      if (Array.isArray(classinfo)) {
        for (const c of classinfo) {
          if (_jac.builtin.issubclass(cls, c)) return true;
        }
        return false;
      }
      // When either side names a builtin type, compare by the shared subclass
      // relation (covers `object`, `bool` ⊂ `int`, and identity).
      const subTag = _jac.builtin._typeTag(cls);
      const supTag = _jac.builtin._typeTag(classinfo);
      if (typeof subTag === "string" || typeof supTag === "string") {
        return _jac.builtin._tagSubclass(subTag, supTag);
      }
      if (cls === classinfo) return true;
      let proto = cls;
      while (proto) {
        if (proto === classinfo) return true;
        proto = Object.getPrototypeOf(proto);
      }
      return false;
    },
    id(o) {
      if (o === null || o === undefined) return 0;
      if (typeof o === "number") return o;
      return typeof o === "string" ? _jac.builtin._strHash(o) : 0;
    },
    _strHash(s) {
      let h = 0;
      for (let i = 0; i < s.length; i++) {
        h = ((h << 5) - h + s.charCodeAt(i)) | 0;
      }
      return h;
    },
    jid(obj) {
      if (obj === null || obj === undefined) {
        throw new _jac.exc.TypeError(
          "jid() called on " + String(obj)
          + " -- the server may have returned an error instead of a node."
          + " Check that your endpoint returned successfully before using jid()."
        );
      }
      if (obj._jac_id === undefined) {
        throw new _jac.exc.TypeError(
          "jid() expected a node or edge with graph identity, but received "
          + (typeof obj === "object" ? JSON.stringify(Object.keys(obj)) : typeof obj)
          + ". Only node and edge archetypes have a jid."
        );
      }
      return obj._jac_id;
    },
    // unsafe_html(x) returns a sentinel object that the JSX flattener
    // recognises and renders as raw HTML via dangerouslySetInnerHTML.
    // Named "unsafe" so the security implication is visible at the use site.
    unsafe_html(html) {
      return { __jacUnsafeHtml: String(html == null ? "" : html) };
    },
    hash(obj) { return _jac.builtin.id(obj); },
    repr(obj) { return JSON.stringify(obj); },
    pow(base, exp, mod) {
      let result = Math.pow(base, exp);
      if (mod !== undefined) result = ((result % mod) + mod) % mod;
      return result;
    },
    next(iter, default_) {
      const result = iter.next();
      if (result.done) {
        if (default_ !== undefined) return default_;
        throw new _jac.exc.StopIteration("StopIteration");
      }
      return result.value;
    },
    vars(o) {
      if (o === undefined) return {};
      const result = {};
      for (const [k, v] of Object.entries(o)) {
        if (typeof v !== "function") result[k] = v;
      }
      return result;
    },
    dir(o) {
      if (o === undefined) return [];
      return Object.getOwnPropertyNames(o).sort();
    },
    open() { throw new _jac.exc.OSError("open() is not supported in client-side JavaScript"); },
    format(value, format_spec) {
      if (!format_spec) return String(value);
      return String(value);
    },
    ascii(obj) {
      if (typeof obj === "string") {
        let r = "'";
        for (const c of obj) {
          const code = c.charCodeAt(0);
          if (c === "\\") r += "\\\\";
          else if (c === "'") r += "\\'";
          else if (code >= 0x20 && code <= 0x7e) r += c;
          else if (code < 0x100) r += "\\x" + code.toString(16).padStart(2, "0");
          else r += "\\u" + code.toString(16).padStart(4, "0");
        }
        return r + "'";
      }
      return String(obj);
    },
    complex(re, im) { return {re: re || 0, im: im || 0}; },
    bool(x) {
      if (x === null || x === undefined || x === false || x === 0 || x === "" || Number.isNaN(x)) return false;
      if (Array.isArray(x)) return x.length > 0;
      if (x instanceof Set || x instanceof Map) return x.size > 0;
      if (typeof x === "object") return Object.keys(x).length > 0;
      return true;
    },
    range(...args) {
      let start, stop, step;
      if (args.length === 1) { start = 0; stop = args[0]; step = 1; }
      else if (args.length === 2) { start = args[0]; stop = args[1]; step = 1; }
      else { start = args[0]; stop = args[1]; step = args[2]; }
      if (step === 0) throw new _jac.exc.ValueError("range() arg 3 must not be zero");
      const result = [];
      if (step > 0) { for (let i = start; i < stop; i += step) result.push(i); }
      else { for (let i = start; i > stop; i += step) result.push(i); }
      return result;
    },
    slice(...args) {
      if (args.length === 1) return { start: null, stop: args[0], step: null };
      return { start: args[0] !== undefined ? args[0] : null, stop: args[1] !== undefined ? args[1] : null, step: args[2] !== undefined ? args[2] : null };
    },
    format(value, format_spec) {
      if (!format_spec || format_spec === "") return String(value);
      const m = format_spec.match(/^([<>^]?)(\d+)?(?:\.(\d+))?([dfseboxXn%]?)$/);
      if (!m) return String(value);
      const [, align, widthStr, precStr, ftype] = m;
      let s;
      const prec = precStr !== undefined ? parseInt(precStr) : undefined;
      if (ftype === "f" || ftype === "") {
        s = prec !== undefined ? Number(value).toFixed(prec) : String(value);
      } else if (ftype === "d") {
        s = String(Math.floor(Number(value)));
      } else if (ftype === "b") {
        s = Number(value).toString(2);
      } else if (ftype === "o") {
        s = Number(value).toString(8);
      } else if (ftype === "x") {
        s = Number(value).toString(16);
      } else if (ftype === "X") {
        s = Number(value).toString(16).toUpperCase();
      } else if (ftype === "e") {
        s = prec !== undefined ? Number(value).toExponential(prec) : Number(value).toExponential();
      } else if (ftype === "%") {
        s = (prec !== undefined ? (Number(value) * 100).toFixed(prec) : (Number(value) * 100).toFixed(6)) + "%";
      } else if (ftype === "s" || ftype === "n") {
        s = String(value);
      } else {
        s = String(value);
      }
      if (widthStr) {
        const width = parseInt(widthStr);
        if (s.length < width) {
          const pad = " ".repeat(width - s.length);
          if (align === "<") s = s + pad;
          else if (align === "^") {
            const left = Math.floor((width - s.length) / 2);
            s = " ".repeat(left) + s + " ".repeat(width - s.length - left);
          }
          else s = pad + s;
        }
      }
      return s;
    }
  },

  exc: (() => {
    class BaseException extends Error { constructor(m) { super(m); this.name = 'BaseException'; } }
    class Exception extends BaseException { constructor(m) { super(m); this.name = 'Exception'; } }
    class ArithmeticError extends Exception { constructor(m) { super(m); this.name = 'ArithmeticError'; } }
    class ZeroDivisionError extends ArithmeticError { constructor(m) { super(m); this.name = 'ZeroDivisionError'; } }
    class OverflowError extends ArithmeticError { constructor(m) { super(m); this.name = 'OverflowError'; } }
    class FloatingPointError extends ArithmeticError { constructor(m) { super(m); this.name = 'FloatingPointError'; } }
    class LookupError extends Exception { constructor(m) { super(m); this.name = 'LookupError'; } }
    class IndexError extends LookupError { constructor(m) { super(m); this.name = 'IndexError'; } }
    class KeyError extends LookupError { constructor(m) { super(m); this.name = 'KeyError'; } }
    class ValueError extends Exception { constructor(m) { super(m); this.name = 'ValueError'; } }
    class TypeError_ extends Exception { constructor(m) { super(m); this.name = 'TypeError'; } }
    class AttributeError extends Exception { constructor(m) { super(m); this.name = 'AttributeError'; } }
    class RuntimeError extends Exception { constructor(m) { super(m); this.name = 'RuntimeError'; } }
    class NotImplementedError extends RuntimeError { constructor(m) { super(m); this.name = 'NotImplementedError'; } }
    class RecursionError extends RuntimeError { constructor(m) { super(m); this.name = 'RecursionError'; } }
    class OSError extends Exception { constructor(m) { super(m); this.name = 'OSError'; } }
    class FileNotFoundError extends OSError { constructor(m) { super(m); this.name = 'FileNotFoundError'; } }
    class FileExistsError extends OSError { constructor(m) { super(m); this.name = 'FileExistsError'; } }
    class PermissionError extends OSError { constructor(m) { super(m); this.name = 'PermissionError'; } }
    class TimeoutError extends OSError { constructor(m) { super(m); this.name = 'TimeoutError'; } }
    class IsADirectoryError extends OSError { constructor(m) { super(m); this.name = 'IsADirectoryError'; } }
    class NotADirectoryError extends OSError { constructor(m) { super(m); this.name = 'NotADirectoryError'; } }
    class AssertionError extends Exception { constructor(m) { super(m); this.name = 'AssertionError'; } }
    class ImportError extends Exception { constructor(m) { super(m); this.name = 'ImportError'; } }
    class ModuleNotFoundError extends ImportError { constructor(m) { super(m); this.name = 'ModuleNotFoundError'; } }
    class NameError extends Exception { constructor(m) { super(m); this.name = 'NameError'; } }
    class UnboundLocalError extends NameError { constructor(m) { super(m); this.name = 'UnboundLocalError'; } }
    class StopIteration extends Exception { constructor(m) { super(m); this.name = 'StopIteration'; } }
    class StopAsyncIteration extends Exception { constructor(m) { super(m); this.name = 'StopAsyncIteration'; } }
    class EOFError extends Exception { constructor(m) { super(m); this.name = 'EOFError'; } }
    class MemoryError extends Exception { constructor(m) { super(m); this.name = 'MemoryError'; } }
    class ReferenceError_ extends Exception { constructor(m) { super(m); this.name = 'ReferenceError'; } }
    class KeyboardInterrupt extends BaseException { constructor(m) { super(m); this.name = 'KeyboardInterrupt'; } }
    class SystemExit extends BaseException { constructor(m) { super(m); this.name = 'SystemExit'; } }
    class GeneratorExit extends BaseException { constructor(m) { super(m); this.name = 'GeneratorExit'; } }
    const _all = { BaseException, Exception, ArithmeticError, ZeroDivisionError, OverflowError, FloatingPointError, LookupError, IndexError, KeyError, ValueError, TypeError: TypeError_, AttributeError, RuntimeError, NotImplementedError, RecursionError, OSError, FileNotFoundError, FileExistsError, PermissionError, TimeoutError, IsADirectoryError, NotADirectoryError, AssertionError, ImportError, ModuleNotFoundError, NameError, UnboundLocalError, StopIteration, StopAsyncIteration, EOFError, MemoryError, ReferenceError: ReferenceError_, KeyboardInterrupt, SystemExit, GeneratorExit };
    function matches(e, name) {
      if (name === 'BaseException') return true;
      if (name === 'Exception') return (e instanceof _all.Exception) || !(e instanceof _all.BaseException);
      const cls = _all[name];
      return cls ? (e instanceof cls) : false;
    }
    return Object.assign(_all, { matches });
  })()
};
let SUBMIT_CATEGORIES = ["Engineering", "Tutorials", "Built with Jac", "Community", "Announcements"];
let SESSION_KEY = "blog_submit_session";
function install_submit_helpers() {
  if (window.__readFileB64) {
    return;
  }
  let s = document.createElement("script");
  s.textContent = "window.__readFileB64=function(file){return new Promise(function(res,rej){var r=new FileReader();r.onload=function(){var s=String(r.result||'');var i=s.indexOf('base64,');res({name:file.name,b64:i>=0?s.slice(i+7):''});};r.onerror=function(){rej(new Error('read failed'));};r.readAsDataURL(file);});};window.__loadScriptOnce=function(src){return new Promise(function(res,rej){var f=document.querySelector('script[data-so=\"'+src+'\"]');if(f){res();return;}var el=document.createElement('script');el.src=src;el.setAttribute('data-so',src);el.onload=function(){res();};el.onerror=function(){rej(new Error('load failed'));};document.head.appendChild(el);});};window.__b64EncodeUtf8=function(s){var b=new TextEncoder().encode(s);var bin='';for(var i=0;i<b.length;i++){bin+=String.fromCharCode(b[i]);}return btoa(bin);};";
  document.head.appendChild(s);
}
async function ensure_marked() {
  if (window.marked) {
    return;
  }
  install_submit_helpers();
  try {
    await window.__loadScriptOnce("https://cdn.jsdelivr.net/npm/marked@12/marked.min.js");
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function slugify(text) {
  let low = text.toLowerCase();
  let res = "";
  let prev_dash = false;
  let i = 0;
  let n = low.length;
  while ((i < n)) {
    let ch = low.at(i);
    if ((((ch >= "a") && (ch <= "z")) || ((ch >= "0") && (ch <= "9")))) {
      res = (res + ch);
      prev_dash = false;
    } else {
      if (!prev_dash) {
        res = (res + "-");
        prev_dash = true;
      }
    }
    i = (i + 1);
  }
  while (((res.length > 0) && (res[0] === "-"))) {
    res = res.slice(1);
  }
  while (((res.length > 0) && (res.at((res.length - 1)) === "-"))) {
    res = res.slice(0, (res.length - 1));
  }
  return res;
}
function safe_filename(name) {
  let res = "";
  let i = 0;
  let n = name.length;
  while ((i < n)) {
    let ch = name.at(i);
    let keep = (((((((ch >= "a") && (ch <= "z")) || ((ch >= "A") && (ch <= "Z"))) || ((ch >= "0") && (ch <= "9"))) || (ch === ".")) || (ch === "_")) || (ch === "-"));
    res = (res + (keep ? ch : "-"));
    i = (i + 1);
  }
  return res;
}
function read_session() {
  try {
    let raw = window.sessionStorage.getItem(SESSION_KEY);
    if (raw) {
      return JSON.parse(raw);
    }
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  return null;
}
function save_session(data) {
  try {
    window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function clear_session() {
  try {
    window.sessionStorage.removeItem(SESSION_KEY);
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function set_jac_token(tok) {
  try {
    window.localStorage.setItem("jac_token", tok);
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function clear_jac_token() {
  try {
    window.localStorage.removeItem("jac_token");
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function query_param(name) {
  try {
    let search = String((window.location.search || ""));
    if (search.startsWith("?")) {
      search = search.slice(1);
    }
    for (const pair of search.split("&")) {
      if (pair.includes("=")) {
        let kv = _jac.str.split(pair, "=", 1);
        if ((kv[0] === name)) {
          return String(decodeURIComponent(kv[1].replaceAll("+", " ")));
        }
      }
    }
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
  return "";
}
function site_origin() {
  try {
    return String(window.location.origin);
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      return "";
    } else {
      throw __jac_e;
    }
  }
}
function redirect_uri() {
  let o = site_origin();
  return (o ? (o + "/submit") : "");
}
function copy_text(t) {
  try {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(t);
    } else {
      let ta = document.createElement("textarea");
      ta.value = t;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
  } catch (__jac_e) {
    if (_jac.exc.matches(__jac_e, "Exception")) {
      let _ignore = null;
    } else {
      throw __jac_e;
    }
  }
}
function status_label(status) {
  let mapping = {"in_review": "\ud83d\udfe1 In review", "scheduled": "\ud83d\uddd3\ufe0f Scheduled", "published": "\ud83d\udfe2 Published", "accepted": "\ud83d\udd35 Accepted", "declined": "\u26aa Not accepted"};
  return (mapping[status] ?? status);
}
function Page() {
  const [booting, setBooting] = useState(true);
  const [signed_in, setSigned_in] = useState(false);
  const [profile, setProfile] = useState(null);
  const [gh_enc, setGh_enc] = useState("");
  const [is_reviewer, setIs_reviewer] = useState(false);
  const [auth_error, setAuth_error] = useState("");
  const [tab, setTab] = useState("write");
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [slug_touched, setSlug_touched] = useState(false);
  const [description, setDescription] = useState("");
  const [body, setBody] = useState("");
  const [bio, setBio] = useState("");
  const [cats, setCats] = useState([]);
  const [images, setImages] = useState([]);
  const [preview_html, setPreview_html] = useState("");
  const [edit_pr, setEdit_pr] = useState(0);
  const [edit_is_own, setEdit_is_own] = useState(true);
  const [edit_author, setEdit_author] = useState("");
  const [edit_can_commit, setEdit_can_commit] = useState(true);
  const [is_repost, setIs_repost] = useState(false);
  const [repost_url, setRepost_url] = useState("");
  const [repost_source, setRepost_source] = useState("");
  const [as_team, setAs_team] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submit_error, setSubmit_error] = useState("");
  const [result, setResult] = useState(null);
  const [subs, setSubs] = useState([]);
  const [my_edits, setMy_edits] = useState([]);
  const [subs_loading, setSubs_loading] = useState(false);
  const [subs_error, setSubs_error] = useState("");
  const [subs_busy, setSubs_busy] = useState("");
  const [editing_published, setEditing_published] = useState(false);
  const [edit_existing_prs, setEdit_existing_prs] = useState([]);
  const [editable, setEditable] = useState([]);
  const [editable_loading, setEditable_loading] = useState(false);
  const [editable_error, setEditable_error] = useState("");
  const [editable_filter, setEditable_filter] = useState("");
  const [editable_busy, setEditable_busy] = useState("");
  useEffect(() => {
    (async () => {
      window.scrollTo(0, 0);
      install_submit_helpers();
      let code = query_param("code");
      if (code) {
        try {
          let res = await __jacSpawn("GithubOAuthExchange", "", {"code": code, "redirect_uri": redirect_uri()});
          if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
            let data = res.reports[0];
            if (data["ok"]) {
              let sess = {"gh_enc": String(data["gh_enc"]), "profile": data["profile"], "is_reviewer": _jac.builtin.bool(data["is_reviewer"])};
              save_session(sess);
              set_jac_token(String(data["token"]));
              setGh_enc(String(sess["gh_enc"]));
              setProfile(sess["profile"]);
              setIs_reviewer(_jac.builtin.bool(sess["is_reviewer"]));
              setSigned_in(true);
            } else {
              setAuth_error(String(data["error"]));
            }
          }
        } catch (__jac_e) {
          if (_jac.exc.matches(__jac_e, "Exception")) {
            let e = __jac_e;
            setAuth_error(`Sign-in failed: ${e}`);
          } else {
            throw __jac_e;
          }
        }
        try {
          window.history.replaceState({}, "", "/submit");
        } catch (__jac_e) {
          if (_jac.exc.matches(__jac_e, "Exception")) {
            let _ignore = null;
          } else {
            throw __jac_e;
          }
        }
        setBooting(false);
        return;
      }
      let existing = read_session();
      if (existing) {
        setGh_enc(String(existing["gh_enc"]));
        setProfile(existing["profile"]);
        setIs_reviewer(_jac.builtin.bool(existing["is_reviewer"]));
        setSigned_in(true);
      }
      setBooting(false);
      if (existing) {
        let want = query_param("edit_pr");
        if (want) {
          try {
            window.history.replaceState({}, "", "/submit");
          } catch (__jac_e) {
            if (_jac.exc.matches(__jac_e, "Exception")) {
              let _ignore = null;
            } else {
              throw __jac_e;
            }
          }
          try {
            await load_edit(Math.trunc(Number(want)), String(existing["gh_enc"]));
          } catch (__jac_e) {
            if (_jac.exc.matches(__jac_e, "Exception")) {
              let e = __jac_e;
              setSubs_error(`Could not open PR #${want} for editing: ${e}`);
            } else {
              throw __jac_e;
            }
          }
        }
      }
    })();
  }, []);
  async function begin_signin() {
    try {
      let cfg = await __jacSpawn("GithubOAuthConfig", "", {});
      let client_id = "";
      if (_jac.builtin.bool(_jac.poly.and_(_jac.poly.and_(cfg.reports, () => (cfg.reports.length > 0)), () => cfg.reports[0]["ok"]))) {
        client_id = String(cfg.reports[0]["client_id"]);
      }
      if (!client_id) {
        setAuth_error("Not available at this moment, check again later.");
        return;
      }
      let ru = encodeURIComponent(redirect_uri());
      let url = `https://github.com/login/oauth/authorize?client_id=${client_id}&redirect_uri=${ru}&scope=public_repo`;
      window.location.href = url;
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setAuth_error(`Could not start sign-in: ${e}`);
      } else {
        throw __jac_e;
      }
    }
  }
  function sign_out() {
    clear_session();
    clear_jac_token();
    setSigned_in(false);
    setProfile(null);
    setGh_enc("");
    setIs_reviewer(false);
  }
  function on_title(v) {
    setTitle(v);
    if (!slug_touched) {
      setSlug(slugify(v));
    }
  }
  function cat_selected(c) {
    for (const x of cats) {
      if ((x === c)) {
        return true;
      }
    }
    return false;
  }
  function toggle_cat(c) {
    if (cat_selected(c)) {
      setCats(cats.filter(x => (x !== c)).map(x => x));
    } else {
      setCats([...cats, ...[c]]);
    }
  }
  function make_cat_toggle(c) {
    function handler() {
      toggle_cat(c);
    }
    return handler;
  }
  async function on_files(files) {
    let new_imgs = images;
    for (const f of files) {
      try {
        let r = await window.__readFileB64(f);
        new_imgs = [...new_imgs, ...[{"name": String(r.name), "b64": String(r.b64)}]];
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let _ignore = null;
        } else {
          throw __jac_e;
        }
      }
    }
    setImages(new_imgs);
  }
  function remove_image(name) {
    setImages(images.filter(im => (im["name"] !== name)).map(im => im));
  }
  function insert_image(name) {
    let s = (slug || "your-slug");
    let snippet = `\n![${name}](/assets/${s}/${safe_filename(name)})\n`;
    setBody((body + snippet));
  }
  useEffect(() => {
    (async () => {
      if ((tab === "write")) {
        await ensure_marked();
        try {
          if (window.marked) {
            setPreview_html(String(window.marked.parse((body || ""))));
          }
        } catch (__jac_e) {
          if (_jac.exc.matches(__jac_e, "Exception")) {
            let _ignore = null;
          } else {
            throw __jac_e;
          }
        }
      }
    })();
  }, [body, tab]);
  async function do_submit() {
    setSubmit_error("");
    setResult(null);
    if (!title.trim()) {
      setSubmit_error("Title is required.");
      return;
    }
    if (!slug.trim()) {
      setSubmit_error("Slug is required.");
      return;
    }
    if (!_jac.builtin.bool(cats)) {
      setSubmit_error("Pick at least one category.");
      return;
    }
    if ((is_repost && !repost_url.trim())) {
      setSubmit_error("Add the original article URL, or uncheck \"repost\".");
      return;
    }
    if ((body.trim().length < 50)) {
      setSubmit_error("Post body is too short.");
      return;
    }
    setSubmitting(true);
    let enc_body = body;
    let body_is_b64 = false;
    install_submit_helpers();
    try {
      enc_body = String(window.__b64EncodeUtf8((body || "")));
      body_is_b64 = true;
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        enc_body = body;
        body_is_b64 = false;
      } else {
        throw __jac_e;
      }
    }
    try {
      let reports = [];
      if (editing_published) {
        let ep = await __jacSpawn("EditPublishedPost", "", {"gh_enc": gh_enc, "slug": slug, "title": title, "categories": cats, "description": description, "body_md": enc_body, "body_b64": body_is_b64, "images": images, "pr_number": edit_pr, "is_repost": is_repost, "repost_url": repost_url, "repost_source": repost_source, "as_team": as_team});
        reports = ep.reports;
      } else if ((edit_pr > 0)) {
        let up = await __jacSpawn("UpdatePost", "", {"gh_enc": gh_enc, "pr_number": edit_pr, "title": title, "slug": slug, "categories": cats, "description": description, "body_md": enc_body, "body_b64": body_is_b64, "images": images, "is_repost": is_repost, "repost_url": repost_url, "repost_source": repost_source, "as_team": as_team});
        reports = up.reports;
      } else {
        let sp = await __jacSpawn("SubmitPost", "", {"gh_enc": gh_enc, "title": title, "slug": slug, "categories": cats, "description": description, "body_md": enc_body, "body_b64": body_is_b64, "author_bio": bio, "images": images, "is_repost": is_repost, "repost_url": repost_url, "repost_source": repost_source, "as_team": as_team});
        reports = sp.reports;
      }
      if (_jac.builtin.bool(_jac.poly.and_(reports, () => (reports.length > 0)))) {
        let data = reports[0];
        if (data["ok"]) {
          setResult({...data, "edited": (edit_pr > 0), "published_edit": editing_published});
          if (editing_published) {
            try {
              let pv = await __jacSpawn("CreatePreview", "", {"gh_enc": gh_enc, "pr_number": Math.trunc(Number(data["pr_number"])), "origin": site_origin()});
              if (_jac.builtin.bool(_jac.poly.and_(_jac.poly.and_(pv.reports, () => (pv.reports.length > 0)), () => pv.reports[0]["ok"]))) {
                setResult({...result, "preview_url": String(pv.reports[0]["url"])});
              }
            } catch (__jac_e) {
              if (_jac.exc.matches(__jac_e, "Exception")) {
                let _ignore = null;
              } else {
                throw __jac_e;
              }
            }
          }
        } else {
          setSubmit_error(String(data["error"]));
        }
      } else {
        setSubmit_error("No response from the server (the request may have been blocked before it reached the app).");
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setSubmit_error(`Save failed: ${e}`);
      } else {
        throw __jac_e;
      }
    }
    setSubmitting(false);
  }
  function reset_form() {
    setResult(null);
    setEdit_pr(0);
    setTitle("");
    setSlug("");
    setSlug_touched(false);
    setDescription("");
    setBody("");
    setBio("");
    setCats([]);
    setImages([]);
    setPreview_html("");
    setSubmit_error("");
    setIs_repost(false);
    setRepost_url("");
    setRepost_source("");
    setAs_team(false);
    setEditing_published(false);
    setEdit_existing_prs([]);
    setEdit_is_own(true);
    setEdit_author("");
    setEdit_can_commit(true);
  }
  async function load_edit(pr, tok) {
    setSubs_busy(`edit-${pr}`);
    try {
      let res = await __jacSpawn("GetSubmissionForEdit", "", {"gh_enc": tok, "pr_number": pr});
      if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
        let data = res.reports[0];
        if (data["ok"]) {
          reset_form();
          setEdit_pr(pr);
          setEdit_is_own(_jac.builtin.bool(data["is_own"]));
          setEdit_author(String(data["author"]));
          setEdit_can_commit(_jac.builtin.bool(data["can_commit"]));
          setTitle(String(data["title"]));
          setSlug(String(data["slug"]));
          setSlug_touched(true);
          setCats(data["categories"]);
          setDescription(String(data["description"]));
          setBody(String(data["body_md"]));
          setIs_repost(_jac.builtin.bool(data["is_repost"]));
          setRepost_url(String(data["repost_url"]));
          setRepost_source(String(data["repost_source"]));
          setAs_team(_jac.builtin.bool(data["authors"].map(a => (String(a) === "jaseci-team")).some(Boolean)));
          setTab("write");
          window.scrollTo(0, 0);
        } else {
          setSubs_error(String(data["error"]));
        }
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setSubs_error(`Could not load that submission for editing: ${e}`);
      } else {
        throw __jac_e;
      }
    }
    setSubs_busy("");
  }
  async function open_preview(pr) {
    setSubs_busy(`prev-${pr}`);
    try {
      let res = await __jacSpawn("CreatePreview", "", {"gh_enc": gh_enc, "pr_number": pr, "origin": site_origin()});
      if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
        let data = res.reports[0];
        if (data["ok"]) {
          try {
            window.open(String(data["url"]), "_blank");
          } catch (__jac_e) {
            if (_jac.exc.matches(__jac_e, "Exception")) {
              let _ignore = null;
            } else {
              throw __jac_e;
            }
          }
        } else {
          setSubs_error(String(data["error"]));
        }
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setSubs_error(`Could not create preview: ${e}`);
      } else {
        throw __jac_e;
      }
    }
    setSubs_busy("");
  }
  function start_edit(pr) {
    load_edit(pr, gh_enc);
  }
  function result_mode() {
    return (result ? String(_jac.poly.call(result, "get", "mode", "")) : "");
  }
  function save_label() {
    if (editing_published) {
      return ((edit_pr > 0) ? "Save to PR" : "Open edit PR");
    }
    if (((edit_pr > 0) && !edit_is_own)) {
      return (!edit_can_commit ? "Send edit to the author" : "Save to their PR");
    }
    return ((edit_pr > 0) ? "Save changes" : "Submit for review");
  }
  function result_eyebrow() {
    let m = result_mode();
    if ((m === "suggestion")) {
      return "Suggested \u2713";
    }
    if ((m === "comment")) {
      return "Posted \u2713";
    }
    if ((result && result["published_edit"])) {
      return "Edit ready \u2713";
    }
    return ((result && result["edited"]) ? "Saved \u2713" : "Submitted \u2713");
  }
  function result_headline() {
    let m = result_mode();
    if ((m === "suggestion")) {
      return "Your edit is waiting as a suggestion";
    }
    if ((m === "comment")) {
      return "Your edit is posted on the pull request";
    }
    if ((result && result["published_edit"])) {
      return "Your edit is ready for review";
    }
    return ((result && result["edited"]) ? "Your changes were saved" : "Your post is in review");
  }
  function result_deck() {
    let m = result_mode();
    let why = (result ? String(_jac.poly.call(result, "get", "fallback_reason", "")) : "");
    if ((m === "suggestion")) {
      return `The author applies it in one click to accept your revision. Delivered this way because ${why}.`;
    }
    if ((m === "comment")) {
      return `The author copies it over the post file to accept your revision. Delivered this way because ${why}.`;
    }
    if ((result && result["published_edit"])) {
      return "The live post is unchanged until this PR merges. Share the preview link with a reviewer; merging publishes the edit.";
    }
    if ((result && result["edited"])) {
      return "The pull request was updated with your changes.";
    }
    return "A draft pull request was opened. A reviewer will review and schedule it.";
  }
  function make_edit(pr) {
    function h() {
      start_edit(pr);
    }
    return h;
  }
  function make_preview(pr) {
    function h() {
      open_preview(pr);
    }
    return h;
  }
  async function load_subs() {
    setSubs_loading(true);
    setSubs_error("");
    try {
      let res = await __jacSpawn("MySubmissions", "", {"gh_enc": gh_enc});
      if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
        let data = res.reports[0];
        if (data["ok"]) {
          setSubs(data["submissions"]);
          setMy_edits(data["edits"]);
        } else {
          setSubs_error(String(data["error"]));
        }
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setSubs_error(`Could not load submissions: ${e}`);
      } else {
        throw __jac_e;
      }
    }
    setSubs_loading(false);
  }
  async function load_editable() {
    setEditable_loading(true);
    setEditable_error("");
    try {
      let res = await __jacSpawn("ListEditablePosts", "", {"gh_enc": gh_enc});
      if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
        let data = res.reports[0];
        if (data["ok"]) {
          setEditable(data["posts"]);
        } else {
          setEditable_error(String(data["error"]));
        }
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setEditable_error(`Could not load posts: ${e}`);
      } else {
        throw __jac_e;
      }
    }
    setEditable_loading(false);
  }
  async function start_edit_published(s) {
    setEditable_busy(s);
    try {
      let res = await __jacSpawn("GetPublishedPostForEdit", "", {"gh_enc": gh_enc, "slug": s});
      if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
        let data = res.reports[0];
        if (data["ok"]) {
          reset_form();
          setEditing_published(true);
          setTitle(String(data["title"]));
          setSlug(String(data["slug"]));
          setSlug_touched(true);
          setCats(data["categories"]);
          setDescription(String(data["description"]));
          setBody(String(data["body_md"]));
          setIs_repost(_jac.builtin.bool(data["is_repost"]));
          setRepost_url(String(data["repost_url"]));
          setRepost_source(String(data["repost_source"]));
          setAs_team(_jac.builtin.bool(data["authors"].map(a => (String(a) === "jaseci-team")).some(Boolean)));
          setEdit_existing_prs(data["existing_prs"]);
          setEdit_pr(0);
          setTab("write");
          window.scrollTo(0, 0);
        } else {
          setEditable_error(String(data["error"]));
        }
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setEditable_error(`Could not load that post for editing: ${e}`);
      } else {
        throw __jac_e;
      }
    }
    setEditable_busy("");
  }
  function make_edit_published(s) {
    function h() {
      start_edit_published(s);
    }
    return h;
  }
  useEffect(() => {
    (async () => {
      if (((tab === "mine") && signed_in)) {
        await load_subs();
      }
      if (((tab === "edit") && signed_in)) {
        await load_editable();
      }
    })();
  }, [tab]);
  if (booting) {
    return __jacJsx("section", {"className": "container narrow", "style": {"padding": "4rem 0"}}, [__jacJsx("p", {"className": "muted"}, ["Loading…"])]);
  }
  if (!signed_in) {
    return __jacJsx("section", {"className": "container narrow", "style": {"padding": "4rem 0", "maxWidth": "640px"}}, [__jacJsx("p", {"className": "eyebrow"}, ["Contribute"]), __jacJsx("h1", {"className": "display"}, ["Submit a blog post"]), __jacJsx("p", {"className": "post-deck"}, ["Share something insightful with the Jac & Jaseci community. Sign in with GitHub to write a post."]), (auth_error && __jacJsx("p", {"style": {"color": "var(--danger, #c0392b)", "marginTop": "1rem"}}, [auth_error])), __jacJsx("button", {"type": "button", "className": "cta-pill", "style": {"marginTop": "2rem", "display": "inline-flex", "alignItems": "center", "gap": "0.5rem"}, "onClick": () => begin_signin()}, [__jacJsx("svg", {"width": "18", "height": "18", "viewBox": "0 0 24 24", "fill": "currentColor"}, [__jacJsx("path", {"d": "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222 0 1.606-.014 2.898-.014 3.293 0 .322.216.694.825.576C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"}, [])]), "Sign in with GitHub"])]);
  }
  return __jacJsx("section", {"className": "container app", "style": {"padding": "2.5rem 0"}}, [__jacJsx("div", {"style": {"display": "flex", "justifyContent": "space-between", "alignItems": "center", "gap": "1rem", "flexWrap": "wrap"}}, [__jacJsx("div", {"style": {"display": "flex", "alignItems": "center", "gap": "0.6rem"}}, [((profile && profile["avatar"]) && __jacJsx("img", {"src": profile["avatar"], "alt": "", "width": 32, "height": 32, "style": {"borderRadius": "50%"}}, [])), __jacJsx("span", {"className": "muted small"}, ["Signed in as ", __jacJsx("strong", {}, [(profile && profile["name"])])])]), __jacJsx("div", {"style": {"display": "flex", "alignItems": "center", "gap": "0.75rem"}}, [(is_reviewer && __jacJsx(Link, {"to": "/reviewer", "className": "tag"}, ["Reviewer dashboard →"])), __jacJsx("button", {"type": "button", "className": "runnable-copy", "onClick": () => sign_out()}, ["Sign out"])])]), __jacJsx("div", {"className": "tag-row", "style": {"marginTop": "1.5rem", "borderBottom": "1px solid var(--rule)", "paddingBottom": "0.75rem"}}, [__jacJsx("button", {"type": "button", "className": ((tab === "write") ? "tag is-active" : "tag"), "onClick": () => {
    setTab("write");
  }}, ["Write a post"]), __jacJsx("button", {"type": "button", "className": ((tab === "mine") ? "tag is-active" : "tag"), "onClick": () => {
    setTab("mine");
  }}, ["My submissions"]), __jacJsx("button", {"type": "button", "className": ((tab === "edit") ? "tag is-active" : "tag"), "onClick": () => {
    setTab("edit");
  }}, ["Edit a post"])]), (((tab === "write") && result) && __jacJsx("div", {"style": {"padding": "2rem 0"}}, [__jacJsx("p", {"className": "eyebrow"}, [result_eyebrow()]), __jacJsx("h2", {"className": "display", "style": {"fontSize": "1.8rem"}}, [result_headline()]), __jacJsx("p", {"className": "post-deck"}, [result_deck()]), __jacJsx("p", {"style": {"marginTop": "1.5rem", "display": "flex", "gap": "0.75rem", "flexWrap": "wrap"}}, [__jacJsx("a", {"className": "cta-pill", "href": result["pr_url"], "target": "_blank", "rel": "noopener"}, ["View pull request →"]), ((((result_mode() === "suggestion") || (result_mode() === "comment")) && _jac.poly.call(result, "get", "url")) && __jacJsx("a", {"className": "cta-pill", "href": result["url"], "target": "_blank", "rel": "noopener"}, ["Open the comment ↗"])), (_jac.poly.call(result, "get", "preview_url") && __jacJsx("a", {"className": "cta-pill", "href": result["preview_url"], "target": "_blank", "rel": "noopener"}, ["Open preview ↗"])), (_jac.poly.call(result, "get", "preview_url") && __jacJsx("button", {"type": "button", "className": "runnable-copy", "onClick": () => copy_text(String(result["preview_url"]))}, ["Copy preview link"])), __jacJsx("button", {"type": "button", "className": "runnable-copy", "onClick": () => reset_form()}, ["Done"])])])), (((tab === "write") && !result) && __jacJsx("div", {"style": {"paddingTop": "1.5rem"}}, [((((edit_pr > 0) && !editing_published) && edit_is_own) && __jacJsx("p", {"className": "muted small", "style": {"display": "flex", "gap": "0.75rem", "alignItems": "center", "marginBottom": "1rem"}}, ["✏️ Editing submission #", edit_pr, ". Saving adds a commit to the existing PR.", __jacJsx("button", {"type": "button", "className": "runnable-copy", "onClick": () => reset_form()}, ["Cancel edit"])])), ((((edit_pr > 0) && !editing_published) && !edit_is_own) && __jacJsx("div", {"className": "muted small", "style": {"marginBottom": "1rem", "padding": "0.75rem 1rem", "border": "1px solid var(--rule)", "borderRadius": "8px", "background": "var(--bg-elev)"}}, [__jacJsx("div", {"style": {"display": "flex", "gap": "0.75rem", "alignItems": "center", "flexWrap": "wrap"}}, [__jacJsx("span", {}, ["✏️ Copy-editing ", __jacJsx("strong", {}, ["@", edit_author]), "’s submission #", edit_pr, ". Their byline, date and draft state are preserved."]), __jacJsx("button", {"type": "button", "className": "runnable-copy", "onClick": () => reset_form()}, ["Cancel"])]), __jacJsx("div", {"style": {"marginTop": "0.6rem"}}, [((edit_can_commit && "This PR allows maintainer edits, so saving commits straight onto it. If GitHub refuses the push, your version is posted as a one-click suggestion instead.") || "\u26a0\ufe0f This PR does not allow maintainer edits, so saving posts your version as a one-click suggestion for the author to apply. Image uploads can\u2019t travel that way \u2014 only the markdown.")])])), (editing_published && __jacJsx("div", {"className": "muted small", "style": {"marginBottom": "1rem", "padding": "0.75rem 1rem", "border": "1px solid var(--rule)", "borderRadius": "8px", "background": "var(--bg-elev)"}}, [__jacJsx("div", {"style": {"display": "flex", "gap": "0.75rem", "alignItems": "center", "flexWrap": "wrap"}}, [__jacJsx("span", {}, ["✏️ Editing published post ", __jacJsx("code", {}, [slug]), ". It stays live; saving opens a PR — merging publishes the edit."]), __jacJsx("button", {"type": "button", "className": "runnable-copy", "onClick": () => reset_form()}, ["Cancel"])]), ((edit_existing_prs.length > 0) && __jacJsx("div", {"style": {"marginTop": "0.6rem"}}, [__jacJsx("span", {}, ["⚠️ Open edit PR(s) for this post: "]), edit_existing_prs.map(p => __jacJsx("a", {"key": p["number"], "href": p["url"], "target": "_blank", "rel": "noopener", "style": {"marginRight": "0.6rem"}}, ["#", p["number"], " by ", p["author"]])), __jacJsx("div", {"style": {"marginTop": "0.4rem", "display": "flex", "gap": "0.5rem", "alignItems": "center"}}, [__jacJsx("label", {}, ["Save to:"]), __jacJsx("select", {"value": String(edit_pr), "onChange": e => {
    setEdit_pr(Math.trunc(Number(e.target.value)));
  }, "style": {"padding": "0.3rem 0.5rem"}}, [__jacJsx("option", {"value": "0"}, ["A new PR"]), edit_existing_prs.filter(p => (profile && (String(p["author"]).toLowerCase() === String(profile["login"]).toLowerCase()))).map(p => __jacJsx("option", {"key": p["number"], "value": String(p["number"])}, ["Continue your PR #", p["number"]]))])])]))])), __jacJsx("label", {"className": "eyebrow"}, ["Title"]), __jacJsx("input", {"type": "text", "className": "search-input", "placeholder": "A clear, compelling title", "value": title, "onChange": e => on_title(e.target.value)}, []), __jacJsx("label", {"className": "eyebrow", "style": {"marginTop": "1rem", "display": "block"}}, ["Slug"]), __jacJsx("input", {"type": "text", "className": "search-input", "placeholder": "kebab-case-url", "value": slug, "readOnly": ((edit_pr > 0) || editing_published), "style": (((edit_pr > 0) || editing_published) ? {"opacity": "0.6", "cursor": "not-allowed"} : {}), "onChange": e => {
    setSlug_touched(true);
    setSlug(e.target.value);
  }}, []), __jacJsx("p", {"className": "muted small"}, [((((edit_pr > 0) || editing_published) && "Slug can't change when editing: ") || "Your post will live at "), "/blog/posts/", (slug || "your-slug")]), __jacJsx("label", {"className": "eyebrow", "style": {"marginTop": "1rem", "display": "block"}}, ["Categories"]), __jacJsx("div", {"className": "tag-row"}, [SUBMIT_CATEGORIES.map(c => __jacJsx("button", {"key": c, "type": "button", "className": (cat_selected(c) ? "tag is-active" : "tag"), "onClick": make_cat_toggle(c)}, [c]))]), (is_reviewer && __jacJsx(null, {}, [__jacJsx("label", {"className": "eyebrow", "style": {"marginTop": "1rem", "display": "block"}}, ["Byline"]), __jacJsx("label", {"style": {"display": "flex", "alignItems": "center", "gap": "0.5rem", "cursor": "pointer"}}, [__jacJsx("input", {"type": "checkbox", "checked": as_team, "onChange": e => {
    setAs_team(_jac.builtin.bool(e.target.checked));
  }}, []), __jacJsx("span", {"className": "muted small"}, ["Publish under the shared “Jaseci Team” byline instead of your name (reviewers only)"])])])), __jacJsx("label", {"className": "eyebrow", "style": {"marginTop": "1rem", "display": "block"}}, ["Short description (optional)"]), __jacJsx("input", {"type": "text", "className": "search-input", "placeholder": "One-line summary for cards & social previews", "value": description, "onChange": e => {
    setDescription(e.target.value);
  }}, []), __jacJsx("label", {"className": "eyebrow", "style": {"marginTop": "1rem", "display": "block"}}, ["Repost"]), __jacJsx("label", {"style": {"display": "flex", "alignItems": "center", "gap": "0.5rem", "cursor": "pointer"}}, [__jacJsx("input", {"type": "checkbox", "checked": is_repost, "onChange": e => {
    setIs_repost(_jac.builtin.bool(e.target.checked));
  }}, []), __jacJsx("span", {"className": "muted small"}, ["This post is a repost of an external article"])]), (is_repost && __jacJsx("div", {"style": {"marginTop": "0.6rem"}}, [__jacJsx("input", {"type": "text", "className": "search-input", "placeholder": "Original article URL (https://…)", "value": repost_url, "onChange": e => {
    setRepost_url(e.target.value);
  }}, []), __jacJsx("input", {"type": "text", "className": "search-input", "style": {"marginTop": "0.5rem"}, "placeholder": "Source name (optional, e.g. The Example Blog)", "value": repost_source, "onChange": e => {
    setRepost_source(e.target.value);
  }}, []), __jacJsx("p", {"className": "muted small"}, ["A card linking to the original renders at the top of your post, and it's tagged “↗ Repost” on the home page."])])), __jacJsx("label", {"className": "eyebrow", "style": {"marginTop": "1rem", "display": "block"}}, ["Images (optional, ≤100KB each)"]), __jacJsx("input", {"type": "file", "multiple": true, "accept": "image/png,image/jpeg,image/gif,image/webp,image/svg+xml", "onChange": e => on_files(e.target.files)}, []), ((images.length > 0) && __jacJsx("ul", {"style": {"listStyle": "none", "padding": "0", "marginTop": "0.5rem"}}, [images.map(im => __jacJsx("li", {"key": im["name"], "style": {"display": "flex", "alignItems": "center", "gap": "0.5rem", "padding": "0.25rem 0"}}, [__jacJsx("span", {"className": "muted small", "style": {"flex": "1"}}, [im["name"]]), __jacJsx("button", {"type": "button", "className": "runnable-copy", "onClick": () => insert_image(im["name"])}, ["Insert"]), __jacJsx("button", {"type": "button", "className": "runnable-copy", "onClick": () => remove_image(im["name"])}, ["Remove"])]))])), __jacJsx("div", {"style": {"display": "flex", "justifyContent": "space-between", "marginTop": "1rem"}}, [__jacJsx("label", {"className": "eyebrow"}, ["Body (Markdown)"]), __jacJsx("span", {"className": "eyebrow", "style": {"opacity": "0.6"}}, ["Live preview →"])]), __jacJsx("div", {"className": "submit-editor-grid"}, [__jacJsx("textarea", {"className": "search-input", "style": {"minHeight": "420px", "fontFamily": "var(--mono, monospace)", "lineHeight": "1.6", "resize": "vertical"}, "placeholder": "Write your post in Markdown. Use ```jac fences for code, ```mermaid for diagrams.", "value": body, "onChange": e => {
    setBody(e.target.value);
  }}, []), __jacJsx("div", {"className": "prose", "style": {"minHeight": "420px", "maxHeight": "640px", "overflow": "auto", "border": "1px solid var(--rule)", "borderRadius": "8px", "padding": "0.75rem 1.1rem", "background": "var(--bg-elev)", "color": "var(--text)"}, "dangerouslySetInnerHTML": {"__html": (preview_html || "<p class='muted'>Preview appears here as you type\u2026</p>")}}, [])]), (((edit_pr === 0) && !editing_published) && __jacJsx(null, {}, [__jacJsx("label", {"className": "eyebrow", "style": {"marginTop": "1rem", "display": "block"}}, ["Your bio (optional, used if you're a new author)"]), __jacJsx("input", {"type": "text", "className": "search-input", "placeholder": "One sentence about you", "value": bio, "onChange": e => {
    setBio(e.target.value);
  }}, [])])), (submit_error && __jacJsx("p", {"style": {"color": "var(--danger, #c0392b)", "marginTop": "1rem"}}, [submit_error])), __jacJsx("div", {"style": {"display": "flex", "gap": "0.75rem", "marginTop": "1.5rem", "flexWrap": "wrap"}}, [__jacJsx("button", {"type": "button", "className": "cta-pill", "disabled": submitting, "onClick": () => do_submit()}, [((submitting && "Saving\u2026") || save_label())])])])), ((tab === "mine") && __jacJsx("div", {"style": {"paddingTop": "1.5rem"}}, [(subs_loading && __jacJsx("p", {"className": "muted"}, ["Loading your submissions…"])), (subs_error && __jacJsx("p", {"style": {"color": "var(--danger, #c0392b)"}}, [subs_error])), (((!subs_loading && !subs_error) && (subs.length === 0)) && __jacJsx("p", {"className": "muted"}, ["No submissions yet. Write your first post!"])), __jacJsx("ul", {"className": "search-results"}, [subs.map(s => __jacJsx("li", {"key": s["pr_number"], "className": "search-result"}, [__jacJsx("p", {"className": "search-result-title"}, [s["title"]]), __jacJsx("p", {"className": "muted small", "style": {"marginTop": "0.25rem", "display": "flex", "gap": "0.75rem", "flexWrap": "wrap", "alignItems": "center"}}, [__jacJsx("span", {}, [status_label(String(s["status"]))]), (s["schedule_at"] && __jacJsx("span", {}, ["· ", s["schedule_at"]])), __jacJsx("a", {"href": s["pr_url"], "target": "_blank", "rel": "noopener"}, ["PR #", s["pr_number"]]), (s["published_url"] && __jacJsx("a", {"href": s["published_url"], "target": "_blank", "rel": "noopener"}, ["Read live →"])), __jacJsx("button", {"type": "button", "className": "runnable-copy", "disabled": (subs_busy === `prev-${s["pr_number"]}`), "onClick": make_preview(Math.trunc(Number(s["pr_number"])))}, [(((subs_busy === `prev-${s["pr_number"]}`) && "Opening\u2026") || "Preview \u2197")]), ((s["status"] === "in_review") && __jacJsx("button", {"type": "button", "className": "runnable-copy", "disabled": (subs_busy === `edit-${s["pr_number"]}`), "onClick": make_edit(Math.trunc(Number(s["pr_number"])))}, [(((subs_busy === `edit-${s["pr_number"]}`) && "Loading\u2026") || "Edit")]))])]))]), ((my_edits.length > 0) && __jacJsx("div", {"style": {"marginTop": "1.5rem"}}, [__jacJsx("p", {"className": "eyebrow"}, ["Your open edits to published posts"]), __jacJsx("ul", {"className": "search-results"}, [my_edits.map(e => __jacJsx("li", {"key": e["number"], "className": "search-result"}, [__jacJsx("p", {"className": "search-result-title"}, [e["title"]]), __jacJsx("p", {"className": "muted small", "style": {"marginTop": "0.25rem", "display": "flex", "gap": "0.75rem", "flexWrap": "wrap", "alignItems": "center"}}, [__jacJsx("span", {}, ["editing ", __jacJsx("code", {}, [e["slug"]])]), __jacJsx("a", {"href": e["url"], "target": "_blank", "rel": "noopener"}, ["PR #", e["number"]]), __jacJsx("button", {"type": "button", "className": "runnable-copy", "disabled": (subs_busy === `prev-${e["number"]}`), "onClick": make_preview(Math.trunc(Number(e["number"])))}, [(((subs_busy === `prev-${e["number"]}`) && "Opening\u2026") || "Preview \u2197")]), __jacJsx("button", {"type": "button", "className": "runnable-copy", "disabled": (editable_busy === e["slug"]), "onClick": make_edit_published(String(e["slug"]))}, [(((editable_busy === e["slug"]) && "Loading\u2026") || "Continue")])])]))])]))])), ((tab === "edit") && __jacJsx("div", {"style": {"paddingTop": "1.5rem"}}, [__jacJsx("p", {"className": "muted small", "style": {"marginBottom": "0.75rem"}}, ["Edit a published post. Saving opens a PR (the post stays live) and gives you a preview link to share with a reviewer."]), __jacJsx("input", {"type": "text", "className": "search-input", "placeholder": "Filter posts…", "value": editable_filter, "onChange": e => {
    setEditable_filter(e.target.value);
  }}, []), (editable_loading && __jacJsx("p", {"className": "muted", "style": {"marginTop": "0.75rem"}}, ["Loading posts…"])), (editable_error && __jacJsx("p", {"style": {"color": "var(--danger, #c0392b)"}}, [editable_error])), (((!editable_loading && !editable_error) && (editable.length === 0)) && __jacJsx("p", {"className": "muted", "style": {"marginTop": "0.75rem"}}, ["No posts you can edit. Reviewers can edit any post; authors can edit their own."])), __jacJsx("ul", {"className": "search-results"}, [editable.filter(p => (((editable_filter === "") || String(p["title"]).toLowerCase().includes(editable_filter.toLowerCase())) || String(p["slug"]).toLowerCase().includes(editable_filter.toLowerCase()))).map(p => __jacJsx("li", {"key": p["slug"], "className": "search-result"}, [__jacJsx("p", {"className": "search-result-title"}, [p["title"]]), __jacJsx("p", {"className": "muted small", "style": {"marginTop": "0.25rem", "display": "flex", "gap": "0.75rem", "flexWrap": "wrap", "alignItems": "center"}}, [__jacJsx("span", {}, [p["date"]]), __jacJsx("a", {"href": `/blog/posts/${p["slug"]}`, "target": "_blank", "rel": "noopener"}, ["Read live →"]), p["edit_prs"].map(pr => __jacJsx("span", {"key": pr["number"], "style": {"display": "inline-flex", "gap": "0.35rem", "alignItems": "center"}}, [__jacJsx("a", {"href": pr["url"], "target": "_blank", "rel": "noopener"}, ["✏️ PR #", pr["number"], " by ", pr["author"]]), __jacJsx("button", {"type": "button", "className": "runnable-copy", "disabled": (subs_busy === `prev-${pr["number"]}`), "onClick": make_preview(Math.trunc(Number(pr["number"])))}, [(((subs_busy === `prev-${pr["number"]}`) && "\u2026") || "Preview \u2197")])])), __jacJsx("button", {"type": "button", "className": "runnable-copy", "disabled": (editable_busy === p["slug"]), "onClick": make_edit_published(String(p["slug"]))}, [(((editable_busy === p["slug"]) && "Loading\u2026") || "Edit")])])]))])]))]);
}
const page = Page;
/*jac:refresh-boundary*/;
export {page};
//# sourceMappingURL=submit.js.map
